import { render, staticRenderFns } from "./tab4.vue?vue&type=template&id=97a09a9e&scoped=true&"
import script from "./tab4.vue?vue&type=script&lang=js&"
export * from "./tab4.vue?vue&type=script&lang=js&"
import style0 from "./tab4.vue?vue&type=style&index=0&id=97a09a9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a09a9e",
  null
  
)

export default component.exports